import {View} from 'react-native';
import sy from '~/styles';
import {Text, MoreMenu, WarrantyIcon} from '~/components/controls';
import {isRobLeniencyTask} from '~/types/rob';
import CheckIcon from '~/images/md-icons/check/materialicons/24px.svg';
import DiscountIcon from '~/images/md-icons/discount/materialsymbolsoutlined/24px.svg';
import SellIcon from '~/images/md-icons/sell/materialsymbolsoutlined/24px.svg';
import InfoIcon from '~/images/md-icons/info/materialicons/24px.svg';
const ActivityOptions = ({
  selected,
  setSelected,
  hasDiscount,
  hasMarkup,
  toggleHasDiscount,
  toggleHasMarkup,
  taskOptions,
  componentsWithDamageAllowed,
  setShowWarrantyInfoDialog,
  setShowDamageInfoDialog,
  setShowLeniencyActionsheet,
  setShowDamageNotAllowedDialog,
}) => (
  <MoreMenu
    icon={
      <View style={[sy['flex-row'], sy['items-center']]}>
        {hasDiscount && <DiscountIcon fill="#299976" />}
        {hasMarkup && <SellIcon fill="#FF6C00" />}
        {((!hasDiscount && !hasMarkup) ||
          selected.warranty ||
          selected.is_damage) && (
          <WarrantyIcon
            value={{
              warranty: selected.warranty,
              is_damage: selected.is_damage,
            }}
          />
        )}
      </View>
    }
    items={[
      {
        title: 'Korting',
        disabled: taskOptions?.discount === false,
        onPress: () => {
          if (hasMarkup) {
            toggleHasMarkup();
          }
          toggleHasDiscount();
          setSelected((prevState) => ({
            ...prevState,
            warranty: null,
            leniency_amount: null,
            is_damage: false,
          }));
        },
        leadingIcon: hasDiscount ? CheckIcon : null,
      },
      {
        title: 'Toeslag',
        disabled: taskOptions?.markup === false,
        onPress: () => {
          if (hasDiscount) {
            toggleHasDiscount();
          }
          toggleHasMarkup();
          setSelected((prevState) => ({
            ...prevState,
            warranty: null,
            leniency_amount: null,
            is_damage: false,
          }));
        },
        leadingIcon: hasMarkup ? CheckIcon : null,
      },
      {
        title: 'Garantie',
        disabled: taskOptions?.warranty === false,
        leadingIcon: selected.warranty === 'Warranty' ? CheckIcon : null,
        onPress: () => {
          if (hasDiscount) {
            toggleHasDiscount();
          }
          if (hasMarkup) {
            toggleHasMarkup();
          }
          if (selected.warranty === 'Warranty') {
            setSelected({
              ...selected,
              warranty: null,
              leniency_amount: null,
              is_damage: false,
            });
            return;
          }
          setSelected({
            ...selected,
            warranty: 'Warranty',
            leniency_amount: null,
            is_damage: false,
          });
          setShowWarrantyInfoDialog(true);
        },
      },
      {
        title: 'Coulance',
        disabled: taskOptions?.leniency === false,
        leadingIcon: isRobLeniencyTask(selected.warranty) ? CheckIcon : null,
        onPress: () => {
          if (hasDiscount) {
            toggleHasDiscount();
          }
          if (hasMarkup) {
            toggleHasMarkup();
          }
          if (isRobLeniencyTask(selected.warranty)) {
            setSelected({
              ...selected,
              warranty: null,
              leniency_amount: null,
              is_damage: false,
            });
            return;
          }
          setTimeout(() => setShowLeniencyActionsheet(true), 100);
        },
      },
      {
        title: (
          <>
            {componentsWithDamageAllowed ? (
              'Schade'
            ) : (
              <View style={[sy['flex-row'], sy['gap-4']]}>
                <Text>Schade</Text>
                <InfoIcon fill="#4A4A49" height={24} width={24} />
              </View>
            )}
          </>
        ),
        disabled: taskOptions?.damage === false,
        leadingIcon: selected.is_damage ? CheckIcon : null,
        onPress: () => {
          if (componentsWithDamageAllowed) {
            if (hasDiscount) {
              toggleHasDiscount();
            }
            if (hasMarkup) {
              toggleHasMarkup();
            }
            if (selected.is_damage) {
              setSelected({
                ...selected,
                warranty: null,
                leniency_amount: null,
                is_damage: false,
              });
            } else {
              setSelected({
                ...selected,
                warranty: null,
                leniency_amount: null,
                is_damage: true,
              });
              setShowDamageInfoDialog?.(true);
            }
          } else {
            setShowDamageNotAllowedDialog(true);
          }
        },
      },
    ]}
  />
);
export default ActivityOptions;
